import { BaseCard } from '@/components/uiKit/Cards';
import { BeltMap } from './BeltMap';

interface BeltConfig {
  totalLength: number;
  segments: number;
  unit: string;
}

interface BeltMapAndTrendProps {
  malfunctions: any[];
  selectedMalfunctionId: string;
  onMalfunctionClick: (id: string) => void;
  beltConfig?: BeltConfig;
}

export default function BeltMapAndTrend({
  malfunctions,
  selectedMalfunctionId,
  onMalfunctionClick,
  beltConfig,
}: BeltMapAndTrendProps) {
  return (
    <BaseCard
      variant="base"
      classNames={{
        card: 'rounded-lg',
        content: 'h-[90px] flex items-center justify-center overflow-visible p-2',
      }}
    >
      <BeltMap
        malfunctions={malfunctions}
        selectedMalfunctionId={selectedMalfunctionId}
        onMalfunctionClick={onMalfunctionClick}
        beltConfig={beltConfig}
      />
    </BaseCard>
  );
}
